var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanicButtonTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 89633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM13.5174 12C13.5174 12.838 12.8381 13.5173 12.0001 13.5173C11.1622 13.5173 10.4829 12.838 10.4829 12C10.4829 11.1621 11.1622 10.4828 12.0001 10.4828C12.8381 10.4828 13.5174 11.1621 13.5174 12ZM12.0593 3.20016C13.5839 3.21041 15.0798 3.6166 16.4002 4.37894L13.3202 9.71365C12.9241 9.48495 12.4753 9.36309 12.0179 9.36002C11.5605 9.35695 11.1102 9.47277 10.711 9.69613L7.70295 4.32053C9.03349 3.57599 10.5346 3.18992 12.0593 3.20016ZM16.4002 19.621C17.7206 18.8586 18.8203 17.7663 19.5915 16.451C20.3627 15.1358 20.7789 13.6427 20.7994 12.1182L14.6399 12.0354C14.6338 12.4928 14.5089 12.9407 14.2776 13.3353C14.0462 13.7299 13.7163 14.0576 13.3202 14.2863L16.4002 19.621ZM4.34979 16.3487C3.59633 15.0232 3.2002 13.5246 3.2002 12L9.36019 12C9.36019 12.4574 9.47903 12.9069 9.70507 13.3046C9.9311 13.7022 10.2566 14.0343 10.6496 14.2683L7.49822 19.5612C6.18816 18.7812 5.10325 17.6742 4.34979 16.3487Z",
    fill: "#FA1D4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanicButtonTitle);
export default __webpack_public_path__ + "static/media/panicButtonTitle.c18934cdbd121bfce6a38968c9a86c23.svg";
export { ForwardRef as ReactComponent };